require('./../bootstrap');

window.Vue = require('vue');

let eventHub = new Vue();
Vue.prototype.$eventHub = eventHub;
window.$eventHub = eventHub;

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
    preLoad: 2,
    lazyComponent: true
}); 


// Vue.component('FaqAccord', require('./components/FaqAccord.vue'));
// Vue.component('SwiperSlider', require('./components/SwiperSlider.vue'));
Vue.component('TemplatesSliderLight', require('./components/TemplatesSliderLight.vue'));
Vue.component('ViewsSlider', require('./components/ViewsSlider.vue'));
Vue.component('Swiper', require('./components/Swiper.vue'));
Vue.component('SwiperFeaturesNavigation', require('./components/SwiperFeaturesNavigation.vue'));
Vue.component('PricingCalculator', require('./components/PricingCalculator.vue'));
Vue.component('UnlimitedPricing', require('./components/UnlimitedPricing.vue'));
Vue.component('StripeCheckout', require('./components/StripeCheckout.vue'));
Vue.component('FaqAccord', require('./components/FaqAccord.vue'));
Vue.component('SwiperSlider', require('./components/SwiperSlider.vue'));
Vue.component('FeaturesViews', require('./components/FeaturesViews.vue'));
Vue.component('SingleCategoryTemplates', require('./components/SingleCategoryTemplates.vue'));
Vue.component('MegaNav', require('./components/MegaNav.vue'));


// Vue.component('StackedCardsSlider', require('./components/StackedCardsSlider.vue'));

new Vue({
    el: '#app'
});


// WEBPACK FOOTER //
// ./resources/js/frontend/brand-v2.js